import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";

export default function MembershipReturn() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("loading");

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    api.get(`/membership/confirm?session_id=${sessionId}`)
      .then(({ data }) => setState(data.paid ? "paid" : "failed"))
      .catch(() => setState("failed"));
  }, [sessionId]);

  return (
    <PublicLayout>
      <section className="bg-white px-4 py-20 min-h-[60vh] flex items-center">
        <div className="max-w-lg mx-auto text-center w-full">
          {state === "loading" && (
            <>
              <Loader2 size={52} className="animate-spin text-primary mx-auto mb-6" />
              <p className="font-display text-2xl text-primary">Confirming your payment…</p>
            </>
          )}
          {state === "paid" && (
            <>
              <CheckCircle size={64} className="text-green-500 mx-auto mb-6" />
              <h1 className="font-display text-4xl sm:text-5xl text-primary uppercase mb-4">Payment Received!</h1>
              <p className="text-slate-600 text-lg mb-8">
                Your Fun-Nastix membership fee of <strong>£30.00</strong> has been received. Thank you — we look forward to seeing you on the mats!
              </p>
              <Button asChild className="rounded-full font-display text-lg px-10 py-6 bg-primary hover:bg-primary/90">
                <Link to="/">Back to Home</Link>
              </Button>
            </>
          )}
          {state === "failed" && (
            <>
              <XCircle size={64} className="text-destructive mx-auto mb-6" />
              <h1 className="font-display text-4xl sm:text-5xl text-primary uppercase mb-4">Not Confirmed</h1>
              <p className="text-slate-600 text-lg mb-8">
                We couldn't confirm your payment. If you completed checkout, please contact us at{" "}
                <a href="mailto:admin@fun-nastix.co.uk" className="text-primary underline">admin@fun-nastix.co.uk</a>{" "}
                and we'll sort it out.
              </p>
              <Button asChild className="rounded-full font-display text-lg px-10 py-6" variant="outline">
                <Link to="/membership">Try Again</Link>
              </Button>
            </>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
